// Utils
export { dataLayerConfig, virtualPageViewEvent } from '@shared-components-web/utils/dataLayerConfig';
export type { IDataLayerEventConfig, IVirtualPageViewParams } from '@shared-components-web/utils/dataLayerConfig';
export { getDeviceType } from '@shared-components-web/utils/getDeviceType';
export { get12HourTime } from '@shared-components-web/utils/get12HourTime';
export { resolveBrandThemeConfig } from '@shared-components-web/utils/resolveBrandThemeConfig';
export { resolvePhoneNumberFormat } from '@shared-components-web/utils/resolvePhoneNumberFormat';

// Constants
export { STATE_CODE_BY_NAME, STATE_CODES, STATE_NAME_BY_CODE } from '@shared-components-web/constants';

// Context
export { AppContextProvider, useAppContext } from '@shared-components-web/context/AppContextProvider.ctx';
export type { IAppContext, IAppContextProvider } from '@shared-components-web/context/AppContextProvider.ctx';
export {
	FacilityContextProvider,
	useFacilityContext,
} from '@shared-components-web/context/FacilityContextProvider.ctx';
export type { ExtendedFacilities } from '@shared-components-web/context/FacilityContextProvider.ctx';
export {
	OfficeLocationContextProvider,
	useOfficeLocationContext,
} from '@shared-components-web/context/OfficeLocationsContextProvider.ctx';
export { PageThemeContextProvider, usePageThemeContext } from '@shared-components-web/context/PageThemeProvider.ctx';
export type { PageTheme } from '@shared-components-web/context/PageThemeProvider.ctx';

// Theme
export { default as BaseBrandThemeConfig } from '@shared-components-web/theme/BaseBrandThemeConfig';
export { default as TAGThemeProvider } from '@shared-components-web/theme/TAGThemeProvider';

// Types (enums)
export type { IconName } from '@shared-components-web/components/TAGSvgIcon/TAGSvgIcon';
export { BffBrandType, FacilityBrand } from '@shared-components-web/gqlConstants';
export type { TAGBrand } from '@shared-components-web/types';

// Components
export { default as ErrorPage } from '@shared-components-web/components/ErrorPage';
export { default as Footer } from '@shared-components-web/components/Footer';
export { default as NextPage } from '@shared-components-web/components/NextPage/NextPage';
export { default as NextPageHead } from '@shared-components-web/components/NextPage/NextPageHead';
export { default as Session } from '@shared-components-web/components/Session';
export { default as TAGLink } from '@shared-components-web/components/TAGLink';
export { default as TAGSvgIcon } from '@shared-components-web/components/TAGSvgIcon';
